import { cloneElement, FC } from 'react';

import { Flex, StyleProps } from '@bonusly/design-system';

import { useTagState } from './hooks/use-tag-state';
import { Tag } from './types';
import { iconStyle } from './utils/icon-style';

interface TagButtonIconProps extends StyleProps {
	tag: Tag;
}

export const TagButtonIcon: FC<TagButtonIconProps> = ({ tag, ...rest }) => {
	const { isActive, schema } = useTagState(tag);

	return (
		<Flex
			alignItems="center"
			bg={{ base: 'none', xs: 'white' }}
			borderRadius="full"
			boxSize={{ base: 6, xs: 8 }}
			justifyContent="center"
			transitionDuration="normal"
			transitionProperty="common"
			{...(isActive && {
				'data-active': true,
			})}
			{...iconStyle(schema)}
			{...rest}
		>
			{cloneElement(schema.icon, { size: 'sm' })}
		</Flex>
	);
};
